import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import RoleHome from "@/components/RoleHome";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Leaderboard from "@/pages/Leaderboard";
import Clients from "@/pages/Clients";
import Profile from "@/pages/Profile";
import ItineraryBuilder from "@/pages/ItineraryBuilder";
import ClientView from "@/pages/ClientView";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminMaintenance from "@/pages/AdminMaintenance";
import AdminEmailMarketing from "@/pages/AdminEmailMarketing";
import { AdminEmailCampaigns, AdminEmailTemplates } from "@/pages/AdminEmailCampaigns";
import PublicReviews from "@/pages/PublicReviews";
import Referrals from "@/pages/Referrals";
import Suppliers from "@/pages/Suppliers";
import Chat from "@/pages/Chat";
import Training from "@/pages/Training";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RoleHome />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/set-password" element={<ResetPassword />} />
            <Route path="/trip/:token" element={<ClientView />} />
            <Route path="/reviews" element={<PublicReviews />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/leaderboard"
              element={
                <ProtectedRoute>
                  <Leaderboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clients"
              element={
                <ProtectedRoute>
                  <Clients />
                </ProtectedRoute>
              }
            />
            <Route
              path="/referrals"
              element={
                <ProtectedRoute>
                  <Referrals />
                </ProtectedRoute>
              }
            />
            <Route
              path="/suppliers"
              element={
                <ProtectedRoute>
                  <Suppliers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              }
            />
            <Route
              path="/training"
              element={
                <ProtectedRoute>
                  <Training />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/itineraries/:id"
              element={
                <ProtectedRoute>
                  <ItineraryBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/maintenance"
              element={
                <ProtectedRoute adminOnly>
                  <AdminMaintenance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/email-marketing"
              element={
                <ProtectedRoute adminOnly>
                  <AdminEmailMarketing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/email-marketing/campaigns"
              element={
                <ProtectedRoute adminOnly>
                  <AdminEmailCampaigns />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/email-marketing/templates"
              element={
                <ProtectedRoute adminOnly>
                  <AdminEmailTemplates />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<RoleHome />} />
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
